import {Theme} from '@lookiero/aurora';
import StyleSheet from 'react-native-extended-stylesheet';

const {colorBgPrimaryLight, space2, space8} = Theme.get();

export const style = StyleSheet.create({
  stepper: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: colorBgPrimaryLight,
  },
  largeStepper: {
    paddingVertical: space8,
  },
  smallStepper: {
    paddingBottom: space2,
  },
});
